module.exports = __webpack_public_path__ + "static/headshot-scott-lundgren-3x.4ef120dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-scott-lundgren-3x.jpg
// module id = 535
// module chunks = 152909308826437